import React from 'react';

import { useRecordContext, TextField } from 'react-admin';

import { get } from 'lodash';

import Answer from '../Answer';

import languages, { Languages } from '../../../../constants/languages';
import conflictFields from '../../../../constants/conflictFields';
import { TextQuestionParameters } from '../../questionParameters';

const LABEL = {
  [languages.SV]: 'Skatteregistreringsnummer (TIN)',
  [languages.EN]: 'Tax registration number (TIN)',
  [languages.DE]: 'Steueridentifikationsnummer (TIN)',
};

const ValueField = () => {
  const record = useRecordContext();

  const value = get(record, 'value');
  const sx = get(record, 'sx', {});

  return <TextField record={{ value }} sx={sx} source="value" emptyText="-" fontWeight="bold" />;
};

const Tin = ({ extraParameters }: { extraParameters?: TextQuestionParameters }) => {
  const record = useRecordContext();

  const language = record?.language as Languages;

  return (
    <Answer
      label={extraParameters?.label ?? LABEL[language]}
      source="tin"
      datapoint={conflictFields.TIN}
      identificationInfo={undefined}
    >
      <ValueField />
    </Answer>
  );
};

Tin.ValueField = ValueField;

export default Tin;
